import JwtService from "@/jwt-service"

const getters = {
  configWeb () {
    return JSON.parse(JwtService.getWebConfig())
  }
}

export default getters